module.exports = __webpack_public_path__ + "img/unfold-vertical.0c3ed7e5.svg";